/**
 * RiperHooks make it possible to add extra steps to the init process
 * Especially useful if the init is triggered automatically.
 */

const RiperHooks = {
  init: () => {
    const customHooks = window.BeansHooks || window.LianaHooks || {};
    Object.keys(customHooks).forEach(function (key) {
      if (typeof customHooks[key] === 'function' && Object.prototype.hasOwnProperty.call(RiperHooks, key)) {
        RiperHooks[key] = customHooks[key];
      }
    });
  },
  /* This hooks triggers right before main initialization */
  onPreInit: () => {},
  /* This hooks triggers right after main initialization */
  onPostInit: () => {},
};

export default RiperHooks;
